// ** React Imports
import { useEffect, useRef, useState } from 'react'

import { client } from 'src/utils/axios-client';
import { LeadScreenStore, LeadActivity, Lead, NextActivity, LeadAccountStore, ViewType, ActivityDialogStore, LeadCompanyStore, CompanyDialogStore, LeadSprintStore, SprintDialogStore, LeadActivityHistoryStore, ActivityHistoryDialogStore, LeadActivityCadenceStore, CadenceListDialogStore, LeadActivityOutcomeStore, ActivityOutcomes, TwilioStore, DailpadPopupStore } from 'src/stores/LeadStore';
import { getActivityEndpoint, leadEndpoints } from '../../../configs/endpoints';

// ** MUI Imports
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Tooltip from '@mui/material/Tooltip'
import Grid from '@mui/material/Grid'
import _ from 'lodash';
import Button from '@mui/material/Button';
import { ProblemDetails } from '../../../types/ApiErrorResponse';
import { intitializeDevice } from 'src/features/Twilio/TwilioBase';
import { makeOutgoingCall } from 'src/features/Twilio/TwilioBase';
import { callHangup } from 'src/features/Twilio/TwilioBase';
import { callMute } from 'src/features/Twilio/TwilioBase';
import { callUnMute } from 'src/features/Twilio/TwilioBase';
import { sendDigits } from 'src/features/Twilio/TwilioBase';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import VolumeMuteIcon from '@mui/icons-material/VolumeMute';
import DialpadIcon from '@mui/icons-material/Dialpad';
import VoicemailIcon from '@mui/icons-material/Voicemail';

type Props = {
    IsInbound: boolean
}

const PhoneControls = ({IsInbound}: Props) => {
    const outcomesRecord = LeadActivityOutcomeStore.useState(s => s.record);
    const selectedLead = LeadScreenStore.useState(s => s.selectedLead);
    const twilioStore = TwilioStore.useState(s => s.record);
    const [showMute, setShowMute] = useState(true);
    const [showUnMute, setShowUnMute] = useState(false);

    const onSubmit = async () => {
        await client.get(leadEndpoints.gettwiliotoken)
            .then(async (response) => {
                TwilioStore.update(s => { s.record = response.data });

                intitializeDevice(response.data.token, response.data.identity, 'trace');


            }).catch((err: ProblemDetails) => {
                if (err.errors) {
                    for (const [key, value] of Object.entries(err.errors)) {
                        var errorMessage = '';

                        value.forEach((message) => {
                            message += message + '\\'
                        });
                    }
                }
            });
    }

    const sendSMS = async () => {
        await client.get(leadEndpoints.sendsmsmessage)
            .then(async (response) => {


            }).catch((err: ProblemDetails) => {
                if (err.errors) {
                    for (const [key, value] of Object.entries(err.errors)) {
                        var errorMessage = '';

                        value.forEach((message) => {
                            message += message + '\\'
                        });
                    }
                }
            });
    }

    const hangup = () => {
        callHangup();
    }

    const mute = () => {
        setShowMute(false);
        callMute();
        setShowUnMute(true);
    }

    const unMute = () => {
        setShowUnMute(false);
        callUnMute();
        setShowMute(true);
    }

    const sendDigit = (digit: string) => {
        sendDigits(digit);
    }

    const showDialPad = () => {
        DailpadPopupStore.update(s => { s.dialpadDialogMode = true })
    };


    return (
        <Box>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Card variant="outlined">
                        <CardContent>
                            <Box >
                                <Grid container alignContent='left' spacing={2}>
                                    {showMute &&
                                        <Grid item xs={12} md={3} alignItems="center" sx={{ pt: 1, display: 'flex', flexDirection: 'row' }}>
                                            <Tooltip title="Mute" >
                                                <Button size='small' variant="outlined" color="info" sx={{ mr: 3 }} onClick={mute} startIcon={<VolumeOffIcon />}>
                                                    Mute
                                                </Button>
                                            </Tooltip>
                                        </Grid>
                                    }
                                    {showUnMute &&
                                        <Grid item xs={12} md={3} alignItems="center" sx={{ pt: 1, display: 'flex', flexDirection: 'row' }}>
                                            <Tooltip title="Un Mute" >
                                                <Button size='small' variant="outlined" color="info" sx={{ mr: 3 }} onClick={unMute} startIcon={<VolumeMuteIcon />}>
                                                    Un Mute
                                                </Button>
                                            </Tooltip>
                                        </Grid>
                                    }
                                    <Grid item xs={12} md={3} alignItems="center" sx={{ pt: 1, display: 'flex', flexDirection: 'row' }}>
                                        <Tooltip title="Dial Pad" >
                                            <Button size='small' variant="outlined" color="info" sx={{ mr: 3 }} startIcon={<DialpadIcon />} onClick={showDialPad}>
                                                Dail Pad
                                            </Button>
                                        </Tooltip>
                                    </Grid>
                                    {!IsInbound && 
                                        <Grid item xs={12} md={3} alignItems="center" sx={{ pt: 1, display: 'flex', flexDirection: 'row' }}>
                                            <Tooltip title="Play Voicemail" >
                                                <Button size='small' variant="outlined" color="info" sx={{ mr: 3 }} startIcon={<VoicemailIcon />}>
                                                    Play VM
                                                </Button>
                                            </Tooltip>
                                        </Grid>
                                    }
                                </Grid>
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Box>
    )
}

export { PhoneControls }

export default PhoneControls;